import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayoutV2 = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AuthLayoutV2;
